import no from '../Flags/no.svg'
import fr from '../Flags/fr.svg'
import us from '../Flags/us.svg'
import es from '../Flags/es.svg'

export const LanguagesSection = () => {
    return (
        <div class="Section LanguagesSection" id="languages">
            <div class="SectionTitle"><h2>Languages 🗣</h2></div>
            <div class="CardGrid LanguagesGrid">
                <LanguageCard language="Norwegian" proficiency="Native proficiency" image={no}/>
                <LanguageCard language="French" proficiency="Native proficiency" image={fr}/>
                <LanguageCard language="English" proficiency="Full professional proficiency" image={us}/>
                <LanguageCard language="Spanish" proficiency="Limited proficiency" image={es}/>
            </div>
            <p><br></br></p>
        </div>
    )
}

const LanguageCard = (props) => {
    return (
      <div class="Card LanguageCard" style={{padding: "0 0 0 0"}}>
        <div class="LanguageCardBackground" style={{backgroundImage: `url(${props.image})`}}>
          <h3>{props.language}</h3>
          <p>{props.proficiency}</p>
        </div>
      </div>
    )
}